import React from 'react'

import { Button, EnumButtonVariants, Tooltip } from '@insquad/tools'

import { PlayIcon } from 'src/common/components/icons/PlayIcon'
import { VideoIcon } from 'src/common/components/icons/VideoIcon'
import { Interviewer, Maybe } from 'src/graphql/types'

import { CandidateResumeSection } from '../CandidateResumeSection/CandidateResumeSection'

import { InterviewerCard } from './InterviewerCard/InterviewerCard'

import s from './CandidateResumeVideo.module.scss'

export interface ICandidateResumeVideoProps {
  videoLink: Maybe<string> | undefined
  interviewer: Maybe<Interviewer> | undefined
  photo: Maybe<string> | undefined
}

export const CandidateResumeVideo: React.FC<ICandidateResumeVideoProps> = ({
  videoLink,
  interviewer,
  photo,
}) => {
  if (!videoLink) {
    return null
  }

  return (
    <CandidateResumeSection
      title="Video Interview"
      icon={<VideoIcon />}
      contentClassName={s.CandidateResumeVideo}
    >
      <div className={s.CandidateResumeVideo__videoPreview}>
        {!!photo && <img src={photo} alt="" />}

        <div className={s.CandidateResumeVideo__videoOverlay}>
          <Tooltip
            usePopperConfig={{ placement: 'top', offset: [0, 20] }}
            tooltipContent="Sign up to access all functions"
            contentMaxWidth={285}
          >
            {({ setTriggerRef }) => (
              <div ref={setTriggerRef}>
                <Button
                  variant={EnumButtonVariants.SECONDARY}
                  className={s.CandidateResumeVideo__btn}
                  iconLeft={<PlayIcon />}
                  disabled
                >
                  Watch Demo
                </Button>
              </div>
            )}
          </Tooltip>
        </div>
      </div>

      {interviewer && <InterviewerCard {...interviewer} />}
    </CandidateResumeSection>
  )
}
